import * as React from "react";
import LinkifyReact from "linkify-react";
const Linkify = ({ children, shouldOpenInNewTab }) => /* @__PURE__ */ React.createElement(LinkifyReact, { options: shouldOpenInNewTab ? { target: "_blank" } : void 0 }, children);
export {
  Linkify
};
//# sourceMappingURL=linkify.js.map
